import { makeAutoObservable } from 'mobx';

const KEY = 'rpso-analytics-consent-v2';
// granted — посетитель нажал «Принять»; denied — явный отказ в прежнем уведомлении (до 28.10.2026),
// его уважаем и аналитику не включаем; null — уведомление ещё не закрыто
type Consent = 'granted' | 'denied' | null;

class AnalyticsConsentStore {
  consent: Consent = null;

  constructor() {
    makeAutoObservable(this);
    if (typeof window === 'undefined') return;
    try {
      const saved = localStorage.getItem(KEY);
      if (saved === 'granted' || saved === 'denied') this.consent = saved;
    } catch {
      /* При запрете хранилища решение действует до закрытия страницы. */
    }
  }

  choose = (consent: Exclude<Consent, null>) => {
    this.consent = consent;
    try {
      localStorage.setItem(KEY, consent);
    } catch {
      /* Выбор остаётся в памяти. */
    }
  };
}

export const analyticsConsentStore = new AnalyticsConsentStore();
